var ProxyRepository = require("app/Domain/Ott/Api/V2/ProxyRepository"),
    MediaRepository = require("app/Domain/Ott/Api/V2/DataAccess/Media/Repository"),
    kind            = require("enyo/kind");

/**
 * This object retrieves Series items from the API.
 */
module.exports = kind.singleton(/** @lends app.Domain.Ott.Api.V2.DataAccess.Series.Repository.prototype */ {

    /**
     * @private
     */
    name: "app.Domain.Ott.Api.V2.DataAccess.Series.Repository",

    /**
     * @private
     */
    kind: ProxyRepository,

    /**
     * @private
     */
    repository: MediaRepository,

    // API
    // --------------------------------

    /**
     * @param    {boolean}  skipCache  Whether to skip the cache
     * @param    {number}   language   The language
     * @param    {string}   slug       The slug
     * @returns  {Promise}  A Promise that resolves with the API response
     * @public
     */
    getBySlug: function(skipCache, language, slug) {
        return this.repository.getByTypeAndSlug(skipCache, language, "series", slug);
    },

    /**
     * @param    {boolean}  skipCache  Whether to skip the cache
     * @param    {number}   language   The language
     * @param    {string}   id         The identifier
     * @returns  {Promise}  A Promise that resolves with the API response
     * @public
     */
    getById: function(skipCache, language, id) {
        return this.repository.getByTypeAndId(skipCache, language, "series", id);
    }

});
